import InternalAPI from "@/app/baseAxios.js"

/** @borrows InternalAPI */
export default class ProductRepository extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v2/product_detail/data"
    }
    
    async getAll(page, perPage, status, orderBy, priority, q) {
        try {
            /** @type {AxiosResponse<Object>} */
            const res = await this.$axios.get(`${this.endpoint}?page=${page}&per_page=${perPage}&status=${status}&order_by=${orderBy}&priority=${priority}&q=${q}`)
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data.data.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }
}
